export const PRODUCTS = {
  AGNOSTIC: 0,
  POWERMETRICS: 1,
  KLIPS: 2,
}
